import type { FC } from 'react';

import { Button, type ButtonProps } from '@clubspark-react/ui/core';
import { useTranslation } from 'react-i18next';
import { type SetOptional } from 'type-fest';

import ColumnsIcon from 'assets/icons/icn _ 16px  _ columns.svg?react';

const ColumnsButton: FC<SetOptional<ButtonProps, 'children'>> = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Button startIcon={<ColumnsIcon />} variant="tertiary" {...props}>
      {t('columns')}
    </Button>
  );
};

export default ColumnsButton;
